import { Card, Container, Spinner } from "react-bootstrap";
import { IImageGenerationDataModel } from "../../types/imageGeneration";
import { useEffect, useState } from "react";
import { fetchImages, useFetchImages } from "../../hooks/useFetchImages";
import ModelResult from "./ModelResult";
import { useTranslation } from "react-i18next";
import { formatDateToUTC } from "../../utils/dateUtils";
import "./ImageGenerationResultEntry.scss";


interface IImageGenerationResultProps {
    imageGenerationResult: IImageGenerationDataModel;
}

const ImageGenerationResultEntry: React.FC<IImageGenerationResultProps> = ({ imageGenerationResult }) => {
    const { t } = useTranslation();
    const { img, imgTA } = useFetchImages(imageGenerationResult.oe_reference_image);

    const [inputImg, setInputImg] = useState<string | undefined>(undefined);
    useEffect(() => {
        const fetchAndSetImage = async () => {
            setInputImg(await fetchImages(imageGenerationResult.filename));
        };
        fetchAndSetImage();
    }, [imageGenerationResult]);
    //const [vectorizationBatch, setVectorizationBatch] = useState<IVectorizedImageBatchModel>()

    return (
        <div className="card-with-image">
            <Card className="flex-row p-3 pt-0 gap-3 card-batch">
                {imageGenerationResult && (
                    <>
                        <div className="pt-3">
                            <Card className="card-wrap-image">
                                <Card.Body className="d-flex justify-content-center align-items-center">
                                    <Card.Img variant="top" src={inputImg}
                                        alt={imageGenerationResult.filename} />
                                </Card.Body>
                                <Card.Footer className="d-flex flex-column gap-1">
                                    <span>{formatDateToUTC(imageGenerationResult.created_at)}</span>
                                </Card.Footer>
                            </Card>
                        </div>
                        <div className="d-flex flex-wrap gap-3 flex-grow-1 align-items-start">
                            <ModelResult generatedImage={imageGenerationResult} />
                            <Card className="mode-card d-flex flex-column align-items-stretch mt-3">
                                <Card.Header
                                    className="fw-bold"
                                    title={t("ImageGeneration.OemTaPairLabelResultPageTooltip")}
                                >
                                    {t("ImageGeneration.OemTaPairLabelResultPage")}
                                </Card.Header>
                                <div className="d-flex flex-row align-items-stretch">
                                    <div className="d-flex flex-column align-items-center p-2">
                                        <Card.Img variant="top" src={img} alt={imageGenerationResult.oe_reference_image} className="image-column-card" />
                                        <Card.Footer className="text-center">
                                            <small>{imageGenerationResult.oe_reference_image.replace("processed_images/", "")}</small>
                                        </Card.Footer>
                                    </div>
                                    <div className="d-flex flex-column align-items-center p-2">
                                        <Card.Img variant="top" src={imgTA} alt={imageGenerationResult.ta_reference_image} className="image-column-card" />
                                        <Card.Footer className="text-center">
                                            <small>{imageGenerationResult.ta_reference_image.replace("processed_images/", "")}</small>
                                        </Card.Footer>
                                    </div>
                                </div>
                            </Card>
                            {/* Prompt display */}
                            {imageGenerationResult.prompt && (
                                <Card
                                    className="mt-3 flex-shrink-1 flex-grow-1 prompt-card prompt-card"
                                >
                                    <Card.Header className="fw-bold ">{t("ImageGeneration.Prompt")}</Card.Header>
                                    <Card.Body className="prompt-card-body">
                                        {imageGenerationResult.prompt}
                                    </Card.Body>
                                </Card>
                            )}
                        </div>
                    </>
                )}
            </Card>
        </div>
    )
}

export default ImageGenerationResultEntry;